import '../Onboarding/Onboarding.css';
import ARButton from '../ARButton/ARButton';


const ARLaunchModal = (props) => {

    const closeButtonClickHandler = function() {
        props.handleArLaunchModalClosed(false);
    }

    return (
        <div className="onboarding">
            <div className="onboarding-box fit-content">
            <div className="btn-close-bar">
            <svg className="btn-close" onClick={closeButtonClickHandler} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 8L8 24" stroke="#F1EFEB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 8L24 24" stroke="#F1EFEB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </div>
                {
            <div className="onboarding-container">
            <img src="./media/Mastercard-logo-no-wordmark.png" className="mastercard-logo" alt="Mastercard logo"/>
            <p className="onboarding-title">How to use the Mastercard Holiday Season AR experience</p>
            <p>Click the button below to view the experience in your space.</p>
            <ARButton 
            modal={true}
            setQRCodeModalVisible={props.setQRCodeModalVisible}
            logArButtonClickedDesktop={props.logArButtonClickedDesktop} 
            logArButtonClickedMobile={props.logArButtonClickedMobile}
      />
            <p></p>
            <div>
                <p className="qr-code-text-footer">Available only on devices that support ARKit and AR Core.</p>
            </div>
            </div>
            }
        </div>
        </div>);
}
 
export default ARLaunchModal;